module.exports = __webpack_public_path__ + "img/Rent.3b505c5e.svg";